import React, { useEffect, useState } from "react";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import { post } from "../../api";
import { CLEAR_BASKET_URL } from "../../api/apiRoutes";
import AccountActivatedDetails from "../HandlerModalByUrl/AccountActivated";
import { LOGIN_PAGE } from "../../routes";
import { useNavigate } from "react-router-dom";
import useActivationUser from "../HandlerModalByUrl/hooks/useActivationUser";
import { useTranslation } from "react-i18next";

const AccountActivated: React.FC = () => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const navigate = useNavigate();
  const [url, setUrl] = useState<string>(window.location.href);
  const { activateUser } = useActivationUser();
  const handleClearBasket = async () => {
    const { isError } = await post(CLEAR_BASKET_URL(facilityIds));
  };

  useEffect(() => {
    if (Boolean(facilityIds)) {
      handleClearBasket();
    }

    const token = url.split("/").pop();

    setTimeout(() => {
      if (token && facilityIds) {
        // console.log("mam token")
        activateUser(token, facilityIds.substring(0, 4) || "");
      }
    }, 200);
  }, [facilityIds]);

  return (
    <div className="account-activated">
      <h2>{t("gratulacje_twoje_konto_jest_juz_aktywne")}</h2>
      <AccountActivatedDetails />
      <div className="flex-center-center">
        <button
          className="button medium padding-medium button-fill-background-second"
          onClick={() => navigate(LOGIN_PAGE)}
        >
          {t("swietnie_zaloguj_sie")}
        </button>
      </div>
    </div>
  );
};

export default AccountActivated;
